import { brand } from '@/brand';

// Классы формы на гостевых страницах — по виду раскладки (brand.layout.auth, см.
// AuthLayout). Формы общие, различается только их сетка: в 'split' поля идут
// столбиком с шагом 26px, в 'card' плотнее (16px), а регистрация — в две колонки.
// Функции, а не константы: поле читается в рендере, так его подменяет тест.

const isCard = () => brand.layout.auth === 'card';

export const authFormClassName = () =>
  isCard() ? 'relative mt-7 flex w-full flex-col gap-4 lg:mt-8' : 'relative mt-[26px] flex w-full flex-col gap-[26px] sm:mt-[32px]';

// Обёртка группы полей. В 'split' — display: contents, то есть сетки нет вовсе и
// поля остаются прямыми элементами формы (разметка прежняя); в 'card' — две
// колонки с планшета.
export const authFieldsGridClassName = () => (isCard() ? 'grid grid-cols-1 gap-4 sm:grid-cols-2' : 'contents');

// Поле на всю ширину сетки (кошелёк и Telegram в регистрации).
export const authFieldFullClassName = () => (isCard() ? 'sm:col-span-2' : '');

// Ошибка сервера. В 'split' — под формой абсолютом (ниже ничего нет); в 'card'
// под формой вопрос со ссылкой, поэтому ошибка в потоке, последней строкой формы.
export const authServerErrorClassName = () =>
  isCard()
    ? 'order-last text-center text-xs text-content-error'
    : 'absolute left-0 top-full w-full translate-y-1 text-center text-xs text-red-400';

// Текст состояния страницы: «Проверяем ссылку…», «Почта подтверждена», ошибка.
// В 'split' — прежний абзац под шапкой, в 'card' — по центру карточки под
// заголовком.
export const authMessageClassName = (tone: 'secondary' | 'error' = 'secondary') => {
  const color = tone === 'error' ? 'text-content-error' : 'text-content-auth-secondary';

  return isCard() ? `mt-4 text-center text-sm ${color}` : `mt-6 ${color} sm:text-lg`;
};
